import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// Reuses .back-button / .back-button-mobile as-is (glass circle, arrow icon,
// responsive swap) — the same design Navigation used to render inline.
import './Navigation.css';
import './ProjectBackButton.css';

// Held back well past the page's own entrance fade, so it doesn't appear
// while the project page is still settling in.
const APPEAR_DELAY_MS = 1800;

// Always returns to the home page with the work panel already open (not
// the plain landing state), since that's the only place project pages are
// ever linked from now that the site-wide nav bar is gone.
const ProjectBackButton: React.FC = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), APPEAR_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const handleBack = () => {
    navigate('/', { state: { openWork: true } });
  };

  return (
    <div className={`project-back-button-wrapper ${visible ? 'is-visible' : ''}`}>
      <button className="back-button" aria-label="Back to work" onClick={handleBack}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
      </button>
      <button className="back-button-mobile" aria-label="Back to work" onClick={handleBack}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
      </button>
    </div>
  );
};

export default ProjectBackButton;
